export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/process", label: "Process" },
  { to: "/packages", label: "Packages" },
  { to: "/team", label: "Team" },
  { to: "/contact", label: "Contact" },
];
